module.exports = __webpack_public_path__ + "static/media/iso.eea507fe.svg";